import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Meal from '../Meal/Meal';
import './FoodTab.css'
import CircularProgress from '@material-ui/core/CircularProgress';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 1400,
  },
}));

export default function FoodTab() {
  const [breakfasts, setBreakfasts] = useState([]);
  const [lunches, setLunches] = useState([]);
  const [dinneres, setDinners] = useState([]);
  
  useEffect(() => {
      fetch('https://red-onion-server-01.herokuapp.com/breakfast')
      .then(res => res.json())
      .then(data => setBreakfasts(data))
  }, [])

  useEffect(() => {
    fetch('https://red-onion-server-01.herokuapp.com/lunch')
    .then(res => res.json())
    .then(data => setLunches(data))
  })

  useEffect(() => {
    fetch('https://red-onion-server-01.herokuapp.com/dinner')
    .then(res => res.json())
    .then(data => setDinners(data))
  }, [])

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
      <div className={classes.root}>
      <AppBar position="static" color="transparent" style={{boxShadow: 'none'}}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="default"
          aria-label="full width tabs example"
          centered
        >
          <Tab label="Breakfast" {...a11yProps(0)} style={{fontWeight: 600}}/>
          <Tab label="Lunch" {...a11yProps(1)} style={{fontWeight: 600}}/>
          <Tab label="Dinner" {...a11yProps(2)} style={{fontWeight: 600}}/>
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
            <div className="food">
            {
                breakfasts.map(breakfast => <Meal time={breakfast}/>)
            }
            </div>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <div className="food">
            {
              lunches.map(lunch => <Meal time={lunch} />)
            }
          </div>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <div className="food">
            {
              dinneres.map(dinner => <Meal time={dinner} />)
            }
          </div>
        </TabPanel>
      </SwipeableViews>
      {
        (breakfasts.length === 0) && <div className="text-center" style={{height: '600px', marginTop: '20px'}}><CircularProgress color="secondary" style={{marginTop: '250px'}}/></div>
      }
    </div>
  );
}